/**
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import { INamedConfigItem, INamedConfigResolver, TGenericBlueprintSchema } from "@adapptio/lib-blueprint";
import { SessionStorageService } from "../SessionStorageService";

/**
 * Session Storage Params Resolver
 */
export class SessionStorageParamsResolver implements INamedConfigResolver {
	public constructor(private sessionStorageSvc: SessionStorageService) {}

	/**
	 * Returns options schema for a given session storages type
	 *
	 * @param name
	 */
	getOptsSchemaByName(name: string): TGenericBlueprintSchema {
		const filterSessionStorage = this.sessionStorageSvc
			.getSessionStorage()
			.find((item) => item.name === name);
		return filterSessionStorage?.optionsSchema || null;
	}

	/**
	 * Return list of session storages
	 *
	 * @return INamedConfigItem[]
	 */
	getNameList(): INamedConfigItem[] {
		return this.sessionStorageSvc.getSessionStorage().map((storage) => ({
			name: storage.name,
			category: storage.category
		}));
	}
}
